import {Component} from '@angular/core';
import * as fromUser from '@app/core/user/store';
import {UserProfile} from '@core/models';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';

@Component({
  selector: 'rh-header-gcs-menu',
  templateUrl: './header-gcs-menu.container.html',
  styleUrls: ['./header-gcs-menu.container.scss'],
})
export class HeaderGcsMenuContainer {
  public opened: true | false = false;
  private account = [192, 'Account', '0 -3222px',
    'https://myaccount.google.com/?utm_source\u003dOGB\u0026authuser\u003d0\u0026utm_medium\u003dapp', '_blank', null, null,
    'https://lh3.google.com/u/0/ogw/ADea4I5ugQAb2QL-OWRXsBL5V7NwYGMLiubGRRbJfKDt\u003ds128-b16-cc-rp-mo'];
  public data = [
    [
      [...this.account],
      [23, 'Gmail', '0 -1116px', 'https://mail.google.com/mail/?authuser\u003d0', '_blank', null, null, ''],
      [49, 'Drive', '0 -1468px', 'https://drive.google.com/?authuser\u003d0', '_blank', null, null, ''],
      [25, 'Docs', '0 -1190px', 'https://docs.google.com/document/?usp\u003ddocs_ald\u0026authuser\u003d0', '_blank', null, null, ''],
      [283, 'Sheets', '0 -3290px', 'https://docs.google.com/spreadsheets/?usp\u003dsheets_ald\u0026authuser\u003d0', '_blank', null, null, ''],
      [281, 'Slides', '0 -2240px', 'https://docs.google.com/presentation/?usp\u003dslides_ald\u0026authuser\u003d0', '_blank', null, null, ''],
      [24, 'Calendar', '0 -2170px', 'https://calendar.google.com/calendar?authuser\u003d0', '_blank', null, null, ''],
      [385, 'Chat', '0 -420px', 'https://chat.google.com/?authuser\u003d0', '_blank', null, null, ''],
      [411, 'Meet', '0 -1050px', 'https://meet.google.com?hs\u003d197\u0026pli\u003d1\u0026authuser\u003d0', '_blank', null, null, ''],
      [330, 'Forms', '0 -1190px', 'https://docs.google.com/forms/?authuser\u003d0\u0026usp\u003dforms_ald', '_blank', null, null, ''],
      [38, 'Sites', '0 -1960px', 'https://sites.google.com/?authuser\u003d0', '_blank', null, null, ''],
      [53, 'Contacts', '0 -3220px', 'https://contacts.google.com/?hl\u003den\u0026authuser\u003d0', '_blank', null, null, ''],
      [53, 'Gemini', '0 -3150px', 'https://gemini.google.com/?utm_source=app_launcher&utm_medium=owned&utm_campaign=base_all', '_blank', null, null, '']
    ],
    [
      [3, 'Groups', '0 -60px', 'https://groups.google.com/d/homeredir?hl\u003den\u0026authuser\u003d0', '_blank', null, null, ''],
      [8, 'Maps', '0 -1320px', 'https://maps.google.com/?authuser=0', '_blank', null, null, ''],
      [426, 'News', '0 -900px', 'https://news.google.com?authuser=0', '_blank', null, null, ''],
      [51, 'Translate', '0 -2590px', 'https://translate.google.com/?authuser=0', '_blank', null, null, ''],
      [136, 'Keep', '0 -700px', 'https://keep.google.com/u/0', '_blank', null, null, ''],
      [258, 'Cloud Search', '0 -630px', 'https://cloudsearch.google.com/cloudsearch?authuser\u003d0', '_blank', null, null, ''],
      [429, 'Earth', '0 -2870px', 'https://earth.google.com/web/?authuser\u003d0', '_blank', null, null, ''],
      [338, 'Saved', '0 -1820px', 'https://www.google.com/save?authuser=0', '_blank', null, null, ''],
      [405, 'Travel', '0 -3360px', 'https://www.google.com/travel/?dest_src\u003dal\u0026authuser\u003d0', '_blank', null, null, ''],
      [674, 'Password Manager', '0 -1610px', 'https://passwords.google.com?utm_source=OGB&utm_medium=AL&authuser=0', '_blank', null, null, ''],
      [44, 'Google Analytics', '0 -3080px', 'https://analytics.google.com/analytics/web?utm_source=OGB&utm_medium=app&authuser=0', '_blank', null, null, ''],
      [682, 'Vids', '0 -150px', 'https://docs.google.com/videos/create?usp=vids_al&authuser=0', '_blank', null, null, ''],
    ]
  ];


  public userProfile$: Observable<UserProfile> = this.store$.pipe(
    select(fromUser.selectUserProfile));


  onMenuClick(): void {
    this.opened = !this.opened;
  }

  clickOutside(): void {
    this.opened = false;
  }

  constructor(private store$: Store<fromUser.State>) {
  }
}
